module.exports = __webpack_public_path__ + "static/media/notification.bfaac754.svg";